module.exports = __webpack_public_path__ + "static/media/whack_img_1.bf263542.png";